module.exports = __webpack_public_path__ + "img/21_67.9c673e33.png";